import api from "./index";
import { ENDPOINTS } from "./endpoints";

export const initiateCheckout = (data) => {
    return api.post(ENDPOINTS.CHECKOUT.INITIATE, data);
};

export const applyStoreCredit = (data) => {
    return api.post(ENDPOINTS.CHECKOUT.APPLY_STORE_CREDIT, data);
};

export const getNearbyStores = (lat, lng) => {
    return api.get(ENDPOINTS.STORES.NEARBY, { params: { lat, lng } });
};

export const getDeliveryProvider = (lat, lng) => {
    return api.get(ENDPOINTS.STORES.DELIVERY_PROVIDER, { params: { lat, lng } });
};

export const getStoreStockStatus = (storeId, variantIds) => {
    return api.get(ENDPOINTS.STORES.STOCK_STATUS(storeId), {
        params: { variantIds: variantIds.join(",") },
    });
};
